const customerLoggedIn = window.customer?.isLoggedIn;
const customerId = window.customer?.id;

export default CONSTANTS = {
  LOCAL_STORAGE_WISHLIST_KEY: 'wishlist',
  LOCAL_STORAGE_DELIMITER: ',',
  BUTTON_ACTIVE_CLASS: 'is-active',
  CUSTOMER_LOGGED_IN: customerLoggedIn,
  CUSTOMER_ID: customerId,
  ALL_WISHLIST_URL: customerId ? `http://netlify.blacklemon.dk/.netlify/functions/getCustomerWishlistProducts?store=ny-form&customerId=${customerId}` : '',
  UPDATE_WISHLIST_URL: customerId ? `http://netlify.blacklemon.dk/.netlify/functions/updateCustomerWishlist?store=ny-form&customerId=${customerId}` : '',
};
